import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ProductList from "./Components/ProductList";
import Index from "./Pages/Index";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Product from "./Components/Product";
import SignIn from "./Pages/SignIn";
import AuthContextProvider from "./Contexts/useAuth";
import ProtectedRoute from "./Routes/ProtectedRoute";
import Home from "./Routes/Home";
import AddUpdateApproveVendor from "./Pages/AddUpdateApproveVendor";
import VendorProfile from "./Components/VendorProfile";
import VendorList from "./Components/VendorList";
import AddUpdateProduct from "./Components/AddUpdateProduct";
import AddUpdateShipment from "./Components/AddUpdateShipment";
import ShipingAndPaymentList from "./Components/ShipingAndPaymentList";
import AddToProductCategoryAndSubCategory from "./Components/AddToProductCategoryAndSubCategory";
import Dashboard from "./Pages/Dashboard";
import DeepLinkService from "./Components/DeepLinkService";
import AdminProtectedRoute from "./Routes/AdminProtectedRoute";
import ResetPassword from "./Pages/ResetPassword";
import AddCustomer from "./Components/AddCustomer";
import AddUpdatePaymentDetails from "./Components/AddUpdatePaymentDetails";
import DownloadDispatchReport from "./Components/DownloadDispatchReport";
import ViewShipmentDetails from "./Components/ViewShipmentDetails";
import UnlockFunctionality from "./Components/UnlockFunctionality";
import AllProducts from "./Components/AllProducts";
import AllShipments from "./Components/AllShipments";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthContextProvider>
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      </AuthContextProvider>
    ),
    children: [
      {
        index: true,
        element: (
          <AuthContextProvider>
            <Index />
          </AuthContextProvider>
        ),
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "products",
        element: <ProductList />,
      },
      {
        path: "all-products",
        element: (
          <AuthContextProvider>
            <AdminProtectedRoute>
              <AllProducts />
            </AdminProtectedRoute>
          </AuthContextProvider>
        ),
      },
      {
        path: "add-product",
        element: <AddUpdateProduct header="Create New Product" />,
      },
      {
        path: "product/:productId",
        element: <Product />,
      },
      {
        path: "vendors",
        element: <VendorList />,
      },
      {
        path: "vendor/:vendorId",
        element: <VendorProfile />,
      },
      {
        path: "add-shipment",
        element: <AddUpdateShipment />,
      },
      {
        path: "add-payment",
        element: <AddUpdatePaymentDetails />,
      },
      {
        path: "shipment-and-payment-list",
        element: <ShipingAndPaymentList />,
      },
      {
        path: "shipment/:shipmentId",
        element: <ViewShipmentDetails />,
      },
      {
        path: "all-shipments",
        element: (
          <AuthContextProvider>
            <AdminProtectedRoute>
              <AllShipments />
            </AdminProtectedRoute>
          </AuthContextProvider>
        ),
      },
      {
        path: "add-to-product-category-and-subcategory",
        element: <AddToProductCategoryAndSubCategory />,
      },
      {
        path: "add-customer",
        element: (
          <AuthContextProvider>
            <AdminProtectedRoute>
              <AddCustomer />
            </AdminProtectedRoute>
          </AuthContextProvider>
        ),
      },
      {
        path: "unlock",
        element: (
          <AuthContextProvider>
            <AdminProtectedRoute>
              <UnlockFunctionality />
            </AdminProtectedRoute>
          </AuthContextProvider>
        ),
      },
      {
        path: "download-dispatch-clearence-report",
        element: <DownloadDispatchReport />,
      },
    ],
  },
  {
    path: "/sign-in",
    element: (
      <AuthContextProvider>
        <SignIn />
      </AuthContextProvider>
    ),
  },
  {
    path: "/sign-up",
    element: <AddUpdateApproveVendor />,
  },
  {
    path: "/dlsrv/:secretCode",
    element: (
      <AuthContextProvider>
        <AdminProtectedRoute>
          <DeepLinkService />
        </AdminProtectedRoute>
      </AuthContextProvider>
    ),
  },
  {
    path: "/changePassword",
    element: <ResetPassword />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
